module.exports = __webpack_public_path__ + "media/images/icons/country_flags/vc-696f1551fbfd85d913021bb3d2fa84ef.svg";